import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { SERVICES } from "@/content/site";

const Status = ({ status }) => status === "available" ? (
  <span className="inline-flex items-center gap-2 border border-white/30 bg-white text-[var(--ink)] px-2.5 py-1 font-mono text-[11px] font-bold uppercase tracking-[0.16em]">
    <span className="h-1.5 w-1.5 rounded-full bg-[var(--red)]" /> Available now
  </span>
) : (
  <span className="inline-flex items-center gap-2 border border-dashed border-[var(--mute)] text-[var(--mute)] px-2.5 py-1 font-mono text-[11px] uppercase tracking-[0.16em]">
    In development · Not yet offered
  </span>
);

const Card = ({ s }) => (
  <article className={`group relative h-full p-7 md:p-9 chamfer border ${s.status === "available" ? "metal metal-edge border-[var(--line)]" : "bg-[var(--char)] border-[var(--line)] border-dashed"}`} data-testid={`service-card-${s.code}`}>
    <div className="flex items-start justify-between gap-4">
      <span className="font-display font-black text-6xl md:text-7xl leading-none stroke-text">{s.code}</span>
      <Status status={s.status} />
    </div>
    <h3 className={`mt-10 font-display font-extrabold uppercase text-3xl md:text-4xl ${s.status === "available" ? "text-white" : "text-[var(--grey)]"}`}>{s.title}</h3>
    <p className="mt-3 text-sm md:text-base text-[var(--grey)] leading-relaxed max-w-md">{s.text}</p>
    <span className="absolute left-0 bottom-0 h-[3px] w-0 bg-[var(--red)] transition-[width] duration-500 group-hover:w-full" aria-hidden />
  </article>
);

export default function Services() {
  return (
    <section className="py-20 md:py-32 border-b border-[var(--line)] bg-[var(--char)]" data-testid="services-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-12 md:mb-16">
          <Reveal className="lg:col-span-7">
            <Eyebrow n="01">Repairs &amp; services</Eyebrow>
            <h2 className="mt-5 font-display font-black uppercase text-5xl md:text-7xl leading-[0.9]">What we can<br />help with</h2>
          </Reveal>
          <Reveal className="lg:col-span-5" delay={0.1}>
            <p className="text-sm md:text-base text-[var(--grey)] leading-relaxed">NE Tool Repair is a growing independent business. Each service is clearly marked so you can see what's on offer right now.</p>
          </Reveal>
        </div>
        <div className="grid md:grid-cols-2 gap-4">
          {SERVICES.map((s, i) => <Reveal key={s.code} delay={(i % 2) * 0.08}><Card s={s} /></Reveal>)}
        </div>
        <Reveal className="mt-10">
          <Link to="/repairs-services" data-testid="services-more-link" className="group inline-flex items-center gap-3 font-display font-extrabold uppercase tracking-[0.14em] text-sm border-b-2 border-[var(--red)] pb-1">
            All repairs &amp; services <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
